/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Close_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Close paste attributes modal" |
*
* @param {Paste_Attributes_Close_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_close_aria_label = /** @type {((inputs?: Paste_Attributes_Close_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Close_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la boite de dialogue de collage des attributs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Modal zum Einfügen von Attributen schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi la finestra modale degli attributi di incolla")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть модальное окно вставки атрибутов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar el modal de pegar atributos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭粘贴属性模态框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("属性貼り付けモーダルを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पेस्ट विशेषताओं को बंद करें मोडल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar modal de atributos de colagem")
	return /** @type {LocalizedString} */ ("Close paste attributes modal")
});